import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useStore } from 'vuex'
import { COMMUNITY_STORE, ROOT_STORE } from './store/constants'
import { debounce } from 'lodash'
import { useRoute } from 'vue-router'
import { onMounted, onUnmounted, onUpdated, watch } from 'vue'
import { apiUrlSubpath } from './constants'
import { MOBILE_WIDTH } from '@/constants/common'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()

const onWidthChange = debounce(() => {
  let isMobile: boolean = window.innerWidth < 992 // BootstrapのLargeを基準とする
  store.dispatch(ROOT_STORE.ACTIONS.CHECK_MOBILE_DEVICE, isMobile)
  const isPhone: boolean = window.innerWidth <= MOBILE_WIDTH
  store.dispatch(ROOT_STORE.ACTIONS.CHECK_PHONE_DEVICE, isPhone)
}, 250)

onMounted(() => {
  window.addEventListener('resize', onWidthChange)
  onWidthChange() //初期表示用に実行
})

onUnmounted(() => window.removeEventListener('resize', onWidthChange))

const route = useRoute()

// noindexを付与しないパス一覧
const notAddNoindex = ['/']

// パスが変わる度にindex/noindexを切り替える
onUpdated(() => {
  const metaRobots = document.querySelector("meta[name='robots']")
  if (notAddNoindex.includes(route.path)) {
    metaRobots?.setAttribute('content', 'index')
  } else {
    metaRobots?.setAttribute('content', 'noindex')
  }
})

watch(
  () => route.params.id,
  () => {
    const type = apiUrlSubpath[route.path.split('/')[1]] ?? 'alumnus'
    if (route.params?.id) {
      store.dispatch(COMMUNITY_STORE.ACTIONS.SET_ME, { id: route.params?.id, type })
      store.dispatch(COMMUNITY_STORE.ACTIONS.SET_COMMUNITY_INFO, route.params?.id)
    }
  }
)

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(route).meta?.layout || 'div'), null, {
    default: _withCtx(() => [
      _createVNode(_component_router_view)
    ]),
    _: 1
  }))
}
}

})